import { makeStyles } from '@material-ui/core/styles';
import { DSTheme } from '../../../styles/themes/types';

export default makeStyles((theme: DSTheme) => ({
  wrapper: {
    display: 'grid',
    placeItems: 'center',
    gridGap: '32px',
    justifyContent: 'center',
    background: theme.palette.background.elevation1,
    boxShadow: '0px 5px 26px rgba(255, 255, 255, 0.04)',
    borderRadius: '16px',
    color: theme.palette.text.primary,

    padding: '32px',
    width: '566px',
  },
  progressRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '28px',

    '& svg.current': {
      marginTop: '5px',
      border: 0,
    },
  },
}));
